import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Help} from '../help';
import {ActivatedRoute, Router} from '@angular/router';
import {HelpService} from '../help.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {

  form: FormGroup;
  help: Help = new Help();
  modulos: string[];
  novoModulo: Boolean = false;

  constructor(formBuilder: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private helpService: HelpService) {
    this.form = formBuilder.group({
      codigo: ['', []],
      modulo: ['', [
        Validators.required
      ]],
      pergunta: ['', [
        Validators.required
      ]],
      respostaSimplificada: ['', [
        Validators.required
      ]],
      respostaCompleta: ['', [
        Validators.required
      ]],
      caminho: ['', [
        Validators.required
      ]],
      data: ['', []]
    });
  }

  ngOnInit() {
    this.helpService.getModulos()
      .subscribe(
        modulos => this.modulos = modulos,
        response => {
          if (response.status === 404) {
            this.router.navigate(['NotFound']);
          }
        });

    const id = this.route.params.subscribe(params => {
      const codigo = params['codigo'];

      if (!codigo) {
        return;
      }

      this.helpService.getHelp(codigo)
        .subscribe(
          help => this.help = help,
          response => {
            if (response.status === 404) {
              this.router.navigate(['NotFound']);
            }
          });
    });
  }

  cancel() {
    const helpValue = this.form.value;

    if (helpValue.codigo) {
      this.router.navigate(['help/' + helpValue.codigo]);
    } else {
      this.router.navigate(['help']);
    }
  }

  save() {
    let result;
    const helpValue = this.form.value;

    if (helpValue.codigo) {
      result = this.helpService.updateHelp(helpValue);
    } else {
      result = this.helpService.addHelp(helpValue);
    }

    result.subscribe(data => {
      this.router.navigate(['help/' + data.codigo]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/help/form/form.component.ts